import React, { Component, Fragment } from 'react';
import NewDropdownNestedContent from './NewDropdownNestedContent';

class NewDropdownNested extends Component {
  render() {
    const { dataNested } = this.props;
    const { links, title, activeNestedTitle } = dataNested;
    return (
      <Fragment>
        <span className="textIndentEfect">{ title }</span>
        <span
          className="chevron chevronLeft left chevronLeftInnerSubmenuWap"
          style={{
            marginTop: '-2px',
            marginRight: '14px',
          }}
        />
        {
          activeNestedTitle === title &&
            <NewDropdownNestedContent links={links} />
        }
      </Fragment>
    );
  }
}

export default NewDropdownNested;
